<template>
  <div class="main-cn">
    <el-row class="searchSection">
      <el-form ref="form" :inline="true" :model="searcheModel">
        <el-form-item label="所属部门">
          <UserCascader
            v-model="searcheModel.branch_id"
            ref="branch"
            :isBusiness="true"
            @change="changeBranch"
          ></UserCascader>
        </el-form-item>
        <el-form-item label="业务员">
          <UserSelect
            ref="user"
            @change="salesmanHandleChange"
          ></UserSelect>
        </el-form-item>
        <el-form-item label="分配时间">
          <el-date-picker
            size="small"
            v-model="searcheModel.created_at"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="分配类型" v-if="searcheModel.active_name == 'all'">
          <el-select size="small" v-model="searcheModel.modify_flag" placeholder="请选择" @change="flagHandleClick">
            <el-option label="手动分配" :value="9"></el-option>
            <el-option label="系统分配" :value="11"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="分配人" v-if="searcheModel.active_name == 'all' && searcheModel.modify_flag == 9">
          <UserSelect
            ref="modify_user"
            @change="modifyFlagHandleChange"
          ></UserSelect>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitSearch"
            >搜索</el-button
          >
          <el-button @click="resetForm()" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row v-loading="loading">
        <el-row class="searchSection">
          <el-tabs v-model="searcheModel.active_name" type="card" @tab-click="handleClick">
            <el-tab-pane label="全部分配" name="all"></el-tab-pane>
            <el-tab-pane label="我的分配" name="my"></el-tab-pane>
          </el-tabs>
        </el-row>
        <el-table 
        v-if="!loading"
        :data="list" 
        border 
        row-key="id" 
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        height="600"
        :header-cell-style="{background: '#f3faff'}"
        :summary-method="getSummaries"
        show-summary
        >
            <el-table-column prop="name" label="部门        |         业务员"></el-table-column>
            <el-table-column prop="sales_num">
              <template slot="header">
                <!-- 自定义表头 -->
                <span>分配线索次数</span>
                <el-tooltip class="item" effect="dark" content="业务员分配到的次数" placement="right">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <!-- 单元格内容 -->
                <el-button type="text" @click="handleView(scope.row)">
                  {{ scope.row.sales_num }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="unbind_num" label="已解绑/转交线索数">
                <template slot-scope="scope">
                    <el-button type="text" @click="dialogShow(scope.row)">
                        {{ scope.row.unbind_num }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="customer_num" label="已关联客户线索数"></el-table-column>
        </el-table>
        <!-- <el-table 
        :data="row_count" 
        border 
        :show-header="false"
        >
          <el-table-column prop="name"></el-table-column>
          <el-table-column prop="sales_num"></el-table-column>
          <el-table-column prop="unbind_num"></el-table-column>
          <el-table-column prop="customer_num"></el-table-column>
        </el-table> -->
    </el-row>
    <UnbindDialog v-if="dialogTableVisible" :params="params" @close="closeDialog"></UnbindDialog>
  </div>
</template>
<style scoped>
</style>
<script>
import ClueCount from "~/services/ClueCount";
import UserCascader from "~/widgets/UserCascader.vue";
import UserSelect from "~/widgets/UserSelect.vue";
import ChannelCascader from "~/widgets/ChannelCascader.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import UnbindDialog from "~/views/count/dialog/UnbindDialog.vue";
import Config from "~/config/params";

export default {
  name: "allocation",

  components: {
    UserSelect,
    UserCascader,
    ChannelCascader,
    ExportFile,
    UnbindDialog,
    Config
  },

  props: {},

  data() {
    return {
      loading: false,
      searcheModel: {},
      list: [],
      active_name: 'allocation',
      unbind_list: [],
      dialogTableVisible: false,
      params: {},
      // row_count: [
      //   {
      //     name: '总计：'
      //   }
      // ]
    };
  },

  mounted() {
    
  },

  created: function () {
    this.resetForm();
  },

  methods: {

    //重置按钮
    resetForm() {
      this.searcheModel = {
        branch_id: "",
        user_id: "",
        created_at: Config.getDataTimes('this_week'),
        active_name: 'all',
        modify_flag: 11,
        modify_uid: ''
      };
      if(this.$refs['branch']){
        this.$refs['branch'].reset();
      }
      if(this.$refs['user']){
        this.$refs['user'].reset();
      }
      if(this.$refs['modify_user']){
        this.$refs['modify_user'].reset();
      }
      this.list = [];
      this.submitSearch();
    },

    // 筛选查询
    submitSearch() {
      this.getList(this.searcheModel);
    },

    //获取列表
    getList(params) {
      // loading 动画
      this.loading = true;
      ClueCount.getList(params, this.active_name)
        .then((res) => {
          if (res.code == 0) {
              this.list = res.data;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },

    //切换部门子组件
    changeBranch(value) {
      if (value.length > 0) {
        // 取得最后一级部门作为所属部门
        this.searcheModel.branch_id = value[value.length - 1];
      } else {
        this.searcheModel.branch_id = "";
      }
    },

    //切换业务员子组件
    salesmanHandleChange(object) {
      this.searcheModel.user_id = object.label;
    },

    //切换操作人子组件
    modifyFlagHandleChange(object) {
      this.searcheModel.modify_uid = object.label;
    },

    dialogShow(item){
        if(item.unbind_num == 0){
            return false;
        }
        this.params = _.clone(this.searcheModel);
        if(item.hasOwnProperty('user_id')){
          this.params['user_id'] = item.user_id;
          this.params['branch_id'] = item.branch_id;
        }else{
          this.params['branch_id'] = item.branch_id;
        }
        this.dialogTableVisible = true;
    },

    closeDialog(val){
        this.dialogTableVisible = false;
        this.params = [];
    },

    // 查看、编辑、删除、绑定、转交销售线索操作
    handleView(val) {
      var operator_id = this.searcheModel.modify_uid;
      if(this.searcheModel.active_name == 'my'){
        operator_id = this.$store.getters.userId;
      }
      if(val.hasOwnProperty('user_id')){
        var query = { operator_id: operator_id, user_id: val.user_id, modify_flag: this.searcheModel.modify_flag, created_at: this.searcheModel.created_at};
      }else{
        var query = { operator_id: operator_id, branch_id: val.branch_id, modify_flag: this.searcheModel.modify_flag, created_at: this.searcheModel.created_at};
      }
      let routeData = this.$router.resolve({
        path: "/sales-leads/logs",
        query: query,
      });
      window.open(routeData.href, '_blank');
    },


    handleClick() {
      if(this.searcheModel.active_name == 'my'){
        this.searcheModel.modify_flag = 11;
        this.searcheModel.modify_uid = '';
      }
      this.submitSearch();
    },

    flagHandleClick(val){
      if(val == 11){
        this.searcheModel.modify_uid = '';
      }
    },

    getRowCount() {
      // 遍历数据，累加顶级行的值
      this.list.forEach(item => {
          // 累加当前项的值，注意转换为数字
          sum += Number(item[column.property]);
        });
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        // 第一列不计算合计，显示自定义的文字内容
        if (index === 0) {
          sums.push('合计：');
          return;
        }
        // 初始化合计值为0
        let sum = 0;
        
        // console.log('sum：', sum);
        // 如果所有值都是数字，则显示合计结果，否则显示'-'
        if (!isNaN(sum)) {
          sums.push(Math.round(sum * 100) / 100); // 保留两位小数
        } else {
          sums.push('--');
        }
      });
      return sums;
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        // 第一列不计算合计，显示自定义的文字内容
        if (index === 0) {
          sums.push('合计：');
          return;
        }
        // 初始化合计值为0
        let sum = 0;
        // 遍历数据，累加顶级行的值
        data.forEach(item => {
          // 累加当前项的值，注意转换为数字
          sum += Number(item[column.property]);
        });
        // 如果所有值都是数字，则显示合计结果，否则显示'-'
        if (!isNaN(sum)) {
          sums.push(Math.round(sum * 100) / 100); // 保留两位小数
        } else {
          sums.push('--');
        }
      });
      return sums;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/count/clue/allocation.vue